import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GetAccountStatusAction } from 'src/app/actions/account.actions';
import { ChequeApiService } from 'src/app/api/cheque.api.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SellCheckGuard  {

  constructor(
      private store: Store,
      private router: Router,
      private chequeApi: ChequeApiService
    ) {}

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.dispatch(new GetAccountStatusAction()).pipe(
      switchMap((accountStatus: any) => {
        const userTypeId = accountStatus.account.accountStatus.userType.id;
        const cuit = accountStatus.userProfile.userProfile?.idNumber;

        if (userTypeId === 'JURIDICA') {
          return of(true);
        }

        if (!cuit) {
          Swal.fire(
            'No pudimos verificar tu perfil',
            'No encontramos la información necesaria para validar tu cuenta.',
            'warning'
          );

          return of(this.router.createUrlTree(['/home']));
        }
        return this.chequeApi.getAdditionalInfoByCuit(cuit).pipe(
          map((data) => {
            if (data.esMonotributo || data.esAutonomo) {
              return true;
            }

            Swal.fire(
              'No podés vender cheques',
              'Tu cuenta no tiene los permisos necesarios para publicar cheques.',
              'warning'
            );

            return this.router.createUrlTree(['/home']);
          }),

          catchError((err) => {
            console.log('Error al verificar información adicional', err);

            Swal.fire(
              'No pudimos verificar tu perfil',
              'No se pudo verificar tu perfil. Por favor, intentá nuevamente más tarde.',
              'warning'
            );

            return of(this.router.createUrlTree(['/home']));
          })
        );
      }),

      catchError((err) => {
        console.log('Error al obtener estado de cuenta', err);

        Swal.fire(
          'No pudimos verificar tu cuenta',
          'No se pudo verificar tu cuenta. Por favor, intentá nuevamente más tarde.',
          'warning'
        );

        return of(this.router.createUrlTree(['/home']));
      })
      );
    }
}
